import request from '../request.js';

/**
 * Simple RESTful resource class
 */
class Resource {
    constructor(uri) {
        this.uri = uri;
    }
    list(query) {
        if (query) {
            return request({
                // url: '/' + this.uri + `?${query}`,
                url: '/' + this.uri + '?' + new URLSearchParams(query).toString(),
                method: 'get',
            });
        } else {
            return request({
                url: '/' + this.uri,
                method: 'get',
            });
        }
    }
    get(id) {
        return request({
            url: '/' + this.uri + '/' + id,
            method: 'get',
        });
    }
    store(resource) {
        return request({
            url: '/' + this.uri,
            method: 'post',
            data: resource,
        });
    }
    update(resource) {
        return request({
            url: '/' + this.uri,
            method: 'put',
            data: resource,
        });
    }
    updatePackage(resource,id) {
        return request({
            url: '/' + this.uri+'/'+id,
            method: 'put',
            data: resource,
        });
    }
    destroy(id) {
        return request({
            url: '/' + this.uri + '/' + id,
            method: 'delete',
        });
    }
    deleteWithGet(id) {
        return request({
            url: '/' + this.uri + '/' + id,
            method: 'get',
        });
    }
    updateUser(resource) {
        return request({
            url: '/' + this.uri,
            method: 'put',
            data: resource,
        });
    }
    report(countryID, ngoID, year) {
        return request({
            url: '/' + this.uri + '/' + countryID + '/' + ngoID + '/' + year,
            method: 'get',
        });
    }
    viewFarmer(userID, roleID) {
        return request({
            url: '/' + this.uri + '/' + userID + '/' + roleID,
            method: 'get',
        });
    }
}

export { Resource as default };


